import {Component} from '@angular/core';
import {Router, RouterLink, RouterLinkActive} from '@angular/router';
import {
  IonApp,
  IonSplitPane,
  IonMenu,
  IonContent,
  IonList,
  IonListHeader,
  IonNote,
  IonMenuToggle,
  IonItem,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonRouterLink,
  IonText
} from '@ionic/angular/standalone';
import {addIcons} from 'ionicons';
import {
  mailOutline,
  mailSharp,
  paperPlaneOutline,
  paperPlaneSharp,
  heartOutline,
  heartSharp,
  archiveOutline,
  archiveSharp,
  trashOutline,
  trashSharp,
  warningOutline,
  warningSharp,
  bookmarkOutline,
  bookmarkSharp,
  peopleOutline,
  personAddOutline,
  logOutOutline,
  search, add, removeOutline, qrCodeOutline,
} from 'ionicons/icons';
import {AuthenticationService} from './services/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {AsyncPipe, NgIf} from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [
    RouterLink, RouterLinkActive, IonApp, IonSplitPane, IonMenu, IonContent, IonList, IonListHeader, IonNote, IonMenuToggle, IonItem, IonIcon, IonLabel, IonRouterLink, IonRouterOutlet, IonText, AsyncPipe, NgIf
  ],
})
export class AppComponent {
  public appPages = [
    {title: 'Patients', url: '/patients', icon: 'people', show: true},
    {title: 'Add patient', url: '/patient-add', icon: 'person-add', show: true},
    {title: 'Scan code', url: '/code', icon: 'qr-code', show: this.checkIfScanner()}
  ];
  public labels = ['Coach', 'Companion', 'Therapy', 'PROM'];

  public userEmail: string;

  constructor(private router: Router, public authenticationService: AuthenticationService, private translate: TranslateService) {
    addIcons({
      mailOutline, mailSharp, paperPlaneOutline, paperPlaneSharp, heartOutline,
      heartSharp, archiveOutline, archiveSharp, trashOutline, trashSharp, warningOutline, warningSharp, bookmarkOutline,
      bookmarkSharp, peopleOutline, personAddOutline, logOutOutline, search, add, removeOutline, qrCodeOutline
    });

    this.translate.addLangs(['de', 'en']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');

    authenticationService.isAuthenticated.subscribe((isAuthenticated) => {
      if(isAuthenticated){
        let user = authenticationService.user;
        this.userEmail = user?.emails[0]?.address;
      }
    })

  }

  checkIfScanner() {
    // @ts-ignore
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.BarcodeDetector){
      return false
    }
    return true;
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/logout']);
  }

}
